import { Button } from "@mui/material";
import {
  PersonAssociatedVersionsParams,
  personService,
} from "../../services/personService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Person } from "../../types/person";
import { PersonAssociatedVersion } from "../../types/version";
import {
  useEntityQueryClient,
  usePaginatedDataQuery,
} from "./entityQueryClient";
import { SnackbarAction } from "notistack";
import { useNavigate } from "react-router-dom";
import { extractPersonEditLink } from "../../components/entitiesReferences/InternalEntityLink";
import usePersonLogic from "../logic/personLogic";

const usePersonQuery = () => {
  const navigate = useNavigate();
  const useFetchAssociatedVersions = (
    personId: string,
    bodyParams: PersonAssociatedVersionsParams = {}
  ) => {
    const hasPersonId = Boolean(personId);

    return usePaginatedDataQuery<
      PersonAssociatedVersion,
      PersonAssociatedVersionsParams
    >({
      collection: SystemEntityCollections.VERSION,
      queryKey: "associatedVersions",
      bodyParams,
      enabled: hasPersonId,
      queryFn: ({ offset, limit, sort, params }) =>
        personService.fetchVersions(personId, offset, limit, sort, params),
    });
  };

  const { defaultPerson, getDisplayName } = usePersonLogic();
  return {
    useFetchAssociatedVersions,
    ...useEntityQueryClient<Person>({
      service: personService,
      collection: SystemEntityCollections.PERSON,
      defaultEntity: defaultPerson,
      snackbarDisplayName: getDisplayName,
      snackbarAction: (data: Person): SnackbarAction => (
        <Button
          variant="text"
          onClick={() => navigate(extractPersonEditLink(data))}
          sx={{ color: "white" }}
        >
          View Person
        </Button>
      ),
    }),
  };
};

export default usePersonQuery;
